import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/TFR/RailQuotationHistory.css';
import createappointmentimg from '../../../Assets/TruckVisits/Assets-Desktop/create-appointment.svg';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { TFR_SERVICE_ENDPOINT } from '../../../Services/config/apiEndPoints';

class RailQuotationHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: false,
            RailHistoryData: []
        }
    }

    getRailQuotationHistory = () => {
        ApiCall(
            'GET',
            serviceBaseURL + TFR_SERVICE_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            },
        ).then((apiData) => {

            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log("in 500");
                    this.setState({ errorMessage: true });
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData);
                    this.setState({ RailHistoryData: apiData });

                }
            }
        });

    }
    componentDidMount = () => {
        this.getRailQuotationHistory();
    }
    createRequest = () => {
        this.props.history.push('/TerminalRequestService')
    }

    render() {

        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.TFRRequestHistoryTitle} description={TitleDescription.TFRRequestHistoryDiscription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Rail Service Request History</small>
                            </div>
                            <div id="RailQuotationHistoryAcceptMobile" className="RailQuotationHistoryNavbarNameRight">
                                <a ><img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                    <small
                                        class="RailQuotationHistoryNavbarRightText"
                                        onClick={() => this.createRequest()}>
                                        Request Service
                                    </small>
                                </a>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <>
                            <nav class="RailQuotationHistoryMobileNavbar">
                                <div className="RailQuotationHistoryNavbarNameRight">
                                    <a ><img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                        <small
                                            class="RailQuotationHistoryNavbarRightText"
                                            onClick={() => this.createRequest()}>
                                            Request Service
                                        </small>
                                    </a>
                                </div>
                            </nav>
                            <hr class="hrRQHMobile" />
                        </>
                        <div class="RailQuotationHistoryPartitionDiv">
                            <div class='RailHeadingDiv'>
                                <small class='RailHeadingSmaill'>For further assistance please contact</small>
                                <small class='RailHeadingSmaillRed'>Transnet.CNC@transnet.net</small>
                            </div>
                            <div id="DataTopDivRailHistory">
                                {!this.state.errorMessage ?
                                    (this.state.RailHistoryData?.map((name, index) => {
                                        return (
                                            <div class="RailHistoryMainCardDiv" >
                                                <div class="RailHistoryDivRow" >

                                                    <div class="RailHistoryMainColumn1">
                                                        <div class='RailHistoryMainColumn'>
                                                            <small id="RailHistoryLable">Request ID</small>
                                                            <small id='RailHistoryValue'>{name?.requestId}</small>
                                                        </div>
                                                        <div class='RailHistoryMainColumn'>
                                                            <small id="RailHistoryLable">Request Date & Time</small>
                                                            <small id='RailHistoryValue'>{FormatTimeStamp(name.responseData?.dateTime).timedateToLocale}</small>
                                                        </div>

                                                        <div class='RailHistoryMainColumn'>
                                                            <small id="RailHistoryLable">Status</small>
                                                            <small id={name?.responseData?.status == 'Mail Sent' ? 'RailHistoryValue' : (name?.responseData?.status == 'Closed' ? 'RailHistoryValueOrange' : 'RailHistoryValueCancled')}>
                                                                {name?.responseData?.status}</small>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }))
                                    :
                                    <div class="notruckfound1">
                                        <small id="nodatamessage1">No result found</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}

export default RailQuotationHistory;